<template>
  <div>
    <Navbar />
    <div class="setting-main-wrapper">
      <div class="main-left-menu">
        <LeftMenu />
      </div>
      <Banner />
      <div class="shop-side p-md-0" ref="scrollContainer">
        <LeftMenuSide :openTabSet="openTabSet" />
        <div class="content-wrap-info">
          <AsociationSingleEvent @scrollToBoxScore="scrollToBoxScoreSection" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/Header/Navbar.vue";
import Banner from "../components/BannerNotify/BannerPage.vue";
import LeftMenu from "../components/Home/LeftMenu.vue";
import AsociationSingleEvent from "../components/Association/AsociationSingleEvent.vue";
import LeftMenuSide from "@/components/NewGameTime/LeftMenuSide.vue";

export default {
  name: "AssociationSingleEventDetail",
  data() {
    return {
      openTabSet: 1,
    };
  },
  components: {
    Navbar,
    LeftMenu,
    Banner,
    AsociationSingleEvent,
    LeftMenuSide
  },
  methods: {
    scrollToBoxScoreSection() {
      this.$nextTick(() => {
        const container = this.$refs.scrollContainer;
        const target = container.querySelector('[ref-box-score-section]'); // safer

        if (container && target) {
          const containerTop = container.getBoundingClientRect().top;
          const targetTop = target.getBoundingClientRect().top;
          const scrollOffset = targetTop - containerTop;

          container.scrollTo({
            top: scrollOffset + container.scrollTop - 66, // -60 for navbar height if needed
            behavior: 'smooth',
          });
        }
      });
    }
  },
  mounted() {
    this.$root.$on("openTabSetting", (id) => {
      this.openTabSet = id;
    });
  },
};
</script>